export const VARIABLE_REGEX = /(?<key>{{(?<variable>.+)}})/g;
